module.exports = {
    getDateFromToday(days = 0) {
        let d = new Date();
        d.setDate(d.getDate() - days);
        return d.toISOString().slice(0, 10);
    },
};
